<template>
  <div class="search_box card animated slideInUp" v-show="isShow">

    <div class="search_bar">
      <slot></slot>
      <!-- 请输入名称 -->
      <el-input size="small" :placeholder='$t("common.t6")' prefix-icon="el-icon-search" v-model="serachData" clearable>
      </el-input>
      <!-- 搜 索 -->
      <el-button type="primary" size="small" @click="search()">{{$t("common.search")}}</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Search",
  props: {},
  data() {
    return {
      isShow: true,
      serachData: "",
    };
  },
  props: {
    // serachData: String,
  },
  created() {},
  watch: {
    // serachData: function (newVal, oldVal) {
    //   this.data = newVal;
    // },
  },
  mounted() {},
  methods: {
    show() {
      this.isShow = true;
    },
    hide() {
      this.isShow = false;
    },
    search() {
      this.$emit("toSearch", this.serachData);
    },
  },
};
</script>
<style scoped lang="scss">
@import "../assets/css/_common.scss";

.search_box {
  width: 90%;
  padding: $m-lit;
  margin: 0 auto;
  margin-top: $m-lit;
  .search_bar {
    display: flex;
    align-items: center;

    .el-input {
      margin-right: $m-lit;
      width: 16rem;
    }
  }
}
</style>
